import Vue from "vue"
import { Component } from "vue-property-decorator"

@Component({})
export default class ValidationMixin extends Vue {
	private static emailRegex: RegExp =
		/^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

	private static objectIdRegex: RegExp = /^[a-f\d]{24}$/i

	public emailFormatIsValid (email: string | null | undefined): boolean {
		if (!email) return false
		return ValidationMixin.emailRegex.test(email)
	}

	public isValidObjectId (id: string | null | undefined): boolean {
		if (!id) return false
		return ValidationMixin.objectIdRegex.test(id)
	}
}
